<template>
  <div class="main-chart-pie">
    <el-row>
      <el-col>
        <div class="header-chart">
          <h4>Objetivos</h4>
          <p>Estos son los objetivos a cumplir durante el año.</p>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <div class="chart-pie">
          <pie-chart
            :labels="labels"
            :datasets="firstTrimester"/>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="list-cards">
          <el-card
            class="card"
            shadow="hover">
            <p>Objetivo Tractores</p>
            <h1>50</h1>
          </el-card>
          <el-card
            class="card"
            shadow="hover">
            <p>Tractores por vender</p>
            <h1>22</h1>
          </el-card>
          <el-card
            shadow="hover"
            class="card">
            <p>Tractores vendidos</p>
            <h1>28</h1>
          </el-card>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="list-cards">
          <el-card
            class="card"
            shadow="hover">
            <p>Objetivo Forrajeros &amp; EE</p>
            <h1>50</h1>
          </el-card>
          <el-card
            class="card"
            shadow="hover">
            <p>Forrajeros &amp; EE por vender</p>
            <h1>11</h1>
          </el-card>
          <el-card
            class="card"
            shadow="hover">
            <p>Forrajeros &amp; EE vendidos</p>
            <h1>39</h1>
          </el-card>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import PieChart from '@/components/_shared/charts/pie-chart'
export default {
  name: 'DashboardChartPie',
  components: {
    PieChart
  },
  props: {
    listStatus: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
      labels: ['Completadas', 'Faltantes'],
      firstTrimester: null,
      valueRange: null,
      optionsRange: [
        {
          label: 'Primer trimestre',
          value: ['2018-01-01', '2018-03-31']
        },
        {
          label: 'Segundo trimestre',
          value: ['2018-04-01', '2018-06-30']
        },
        {
          label: 'Tercer trimestre',
          value: ['2018-07-01', '2018-09-30']
        },
        {
          label: 'Cuarto trimiestre',
          value: ['2018-10-01', '2018-12-31']
        }
      ]
    }
  },
  computed: {
    profile () {
      return this.$store.getters['profile/me']
    }
  },
  mounted () {
    this.firstTrimester = this.calculateChart()
  },
  methods: {
    calculateRange () {
      this.firstTrimester = this.calculateChart()
      /* this.$store.dispatch('seller-goals/query', {limit: 1000, 'filters[whereBetween][createdAt]': [range[0], range[1]]})
        .then(({data}) => {
          if (data.items.length > 0) {
            for (let item of data.items) {
              if (item.type === 'Tractor') {
                this.totalTractors = this.totalTractors + item.sales
              } else {
                this.totalForrajero = this.totalForrajero + item.sales
              }
              this.totalGoals = this.totalGoals + item.sales
            }
          } else {
            this.totalTractors = 0
            this.totalForrajero = 0
            this.totalGoals = 0
          }
        }) */
    },
    calculateChart () {
      let array = []
      let fistValue = Math.round(Math.random() * 100)
      let secondValue = 100 - fistValue
      let data = [fistValue, secondValue]
      array = [{
        data: data,
        backgroundColor: [
          '#FF8206',
          '#FF231E'
        ]
      }]
      return array
    }
  }
}
</script>

<style scoped lang="scss">
  .main-chart-pie{
    margin-top: 30px;
    border-radius: 3px;
    .header-chart{
      height: 60px;
      max-height: 60px;
      background-color: #EFEFEF;
      border: 1px solid #E5E5E5;
      position: relative;
      padding: 10px;
      h4{
        @include font-lato(15px, bold);
        color: $header-tabs-active;
        margin: 10px 0 0 0;
      }
      p {
        @include font-primary(12px, regular);
        color: $items-primary;
      }
      .select{
        position: absolute;
        right: 15px;
        top: 10px;
      }
    }
    .chart-pie{
      display: flex;
      align-items: center;
      background-color: #ffffff;
      height: 350px;
      border-right: 1px solid #E5E5E5;
      border-bottom: 1px solid #E5E5E5;
      border-left: 1px solid #E5E5E5;
    }
    .list{
      border-left: 1px solid $border-primary;
      height: 350px;
      background-color: #ffffff;
      .header-list{
        border-bottom: 1px solid $border-primary;
        .header{
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
      .main-list{
        height: 310px;
        overflow: auto;
        .list-item{
          text-align: center;
          margin: 10px 0;
          @include font-secondary(16px, regular);
          .status{
            .icon-check-circle{
              color:#30B122;
              font-weight: bold;
            }
            .icon-x-circle{
              color: $primary;
              font-weight: bold;
            }
          }
          .total{
            font-weight: 500;
          }
        }
      }
    }
    .list-cards{
      height: 350px;
      background-color: #ffffff;
      .card{
        height: 115px;
        position: relative;
        border-radius: 0px;
        p{
          margin: 0;
          @include font-lato(14px, bold);
          color:#3E3E3E;
        }
        span{
          color: $icon;
          @include font-lato(14px);
        }
        h1{
          margin: 0;
          @include font-primary(36px, light);
          color: #707070;
          margin-top: 20px;
        }
        .foot{
          position: absolute;
          right: 40px;
          bottom: 20px;
          color:#30B122;
          @include font-lato(16px, bold)
        }
        &:hover{
          background-color: #F9F9F9;
          cursor: pointer;
          box-shadow: none;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/modules/dashboard/dashboard-chart-seller.vue